const API_BASE_URL = 'https://web-production-09b1e.up.railway.app';

export const api = {
  // Health check
  healthCheck: async () => {
    const response = await fetch(`${API_BASE_URL}/api/health`);
    return response.json();
  },

  // Get cry classes
  getClasses: async () => {
    const response = await fetch(`${API_BASE_URL}/api/classes`);
    return response.json();
  },

  // Upload file prediction
  predictUpload: async (file, confidenceThreshold = 0.6) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('confidence_threshold', confidenceThreshold);

    const response = await fetch(`${API_BASE_URL}/api/predict/upload`, {
      method: 'POST',
      body: formData,
    });
    return response.json();
  },

  // Record prediction
  predictRecord: async (audioBlob, confidenceThreshold = 0.6) => {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onloadend = async () => {
        const base64Audio = reader.result.split(',')[1];
        
        const response = await fetch(`${API_BASE_URL}/api/predict/record`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            audio_data: base64Audio,
            format: 'base64',
            sample_rate: 16000,
            confidence_threshold: confidenceThreshold,
          }),
        });
        
        const data = await response.json();
        resolve(data);
      };
      reader.onerror = reject;
      reader.readAsDataURL(audioBlob);
    });
  },
};
